export const SET_SHOPPING_LIST = 'set_shopping_list';

export default function setShoppingList(list) {
  return {
    type: SET_SHOPPING_LIST,
    payload: list
  };
}



// WEBPACK FOOTER //
// ./src/actions/set_shopping_list.js